module.exports = __webpack_public_path__ + "img/p3.3a15833b.png";